var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-col gap-4", attrs: { "data-id": _vm.id } },
    [
      _c(
        "div",
        {
          staticClass: "flex items-center gap-3",
          attrs: { "data-id": _vm.id }
        },
        [
          _c(
            "div",
            {
              staticClass: "w-25 flex-shrink-0 rounded shadow-md",
              attrs: { "data-id": _vm.id }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "h-7 flex items-center justify-center rounded-t bg-orange-200",
                  attrs: { "data-id": _vm.id }
                },
                [
                  _c("BlTextBody2", {
                    staticClass: "text-orange-700",
                    attrs: {
                      "data-id": _vm.id,
                      text: _vm.displayDate(_vm.appointment.date, "dddd")
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "h-18 flex flex-col items-center justify-center rounded-b bg-pure-white",
                  attrs: { "data-id": _vm.id }
                },
                [
                  _c("BlTextTitle4", {
                    staticClass: "text-orange-700",
                    attrs: {
                      "data-id": _vm.id,
                      text: _vm.displayDate(_vm.appointment.date, "DD")
                    }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "text-orange-600",
                    attrs: {
                      "data-id": _vm.id,
                      text: _vm.displayDate(_vm.appointment.date, "MMMM")
                    }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "py-3 px-3 flex flex-col",
              attrs: { "data-id": _vm.id }
            },
            [
              _c(
                "div",
                {
                  staticClass: "max-w-54 mb-1 flex items-center gap-1",
                  attrs: { "data-id": _vm.id }
                },
                [
                  _c("BlTextBody2", {
                    attrs: { "data-id": _vm.id, text: "Therapist:" }
                  }),
                  _vm._v(" "),
                  !_vm.appointment.user
                    ? _c("BlTextSubtitle3", {
                        staticClass: "truncate",
                        attrs: { "data-id": _vm.id, text: "-" }
                      })
                    : _c("BlTextSubtitle3", {
                        staticClass: "truncate",
                        class: { "italic ": !_vm.appointment.user.name },
                        attrs: {
                          "data-id": _vm.id,
                          title: _vm.appointment.user.name || "Deleted user",
                          text: _vm.appointment.user.name || "Deleted user"
                        }
                      })
                ],
                1
              ),
              _vm._v(" "),
              _c("BlTextTitle4", {
                staticClass: "mb-3 text-slate-800",
                attrs: {
                  "data-id": _vm.id,
                  text:
                    _vm.appointment.start_time_string +
                    " - " +
                    _vm.appointment.end_time_string
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "flex items-center gap-2",
                  attrs: { "data-id": _vm.id }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "max-w-28 flex items-center gap-2",
                      attrs: { "data-id": _vm.id }
                    },
                    [
                      _vm.enableBranch && _vm.appointment.room.branch
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "h-7 min-w-12 max-w-16 px-2 flex items-center justify-center rounded truncate",
                              style: {
                                backgroundColor:
                                  _vm.appointment.room.branch
                                    .background_color || "unset"
                              },
                              attrs: {
                                "data-id": _vm.id,
                                title: _vm.appointment.room.branch.name
                              }
                            },
                            [
                              _c("BlTextBody2", {
                                staticClass: "truncate",
                                style: {
                                  color:
                                    _vm.appointment.room.branch.color || "unset"
                                },
                                attrs: {
                                  "data-id": _vm.id,
                                  text: _vm.appointment.room.branch.name || "-"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "truncate",
                          attrs: {
                            "data-id": _vm.id,
                            title: _vm.appointment.room.name
                          }
                        },
                        [
                          _c("BlTextBody2", {
                            staticClass: "truncate",
                            attrs: {
                              "data-id": _vm.id,
                              text: _vm.appointment.room.name
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "w-1 h-1 flex-shrink-0 bg-slate-600 rounded",
                    attrs: { "data-id": _vm.id }
                  }),
                  _vm._v(" "),
                  _c("BlChip", {
                    attrs: { "data-id": _vm.id, chip: _vm.appointment.status }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.useAction
            ? _c(
                "div",
                {
                  staticClass: "relative ml-auto flex items-center",
                  attrs: { "data-id": _vm.id }
                },
                [
                  _c("BlInputButton", {
                    attrs: {
                      "data-id": _vm.id,
                      type: "outlined",
                      icon: "dots-vertical",
                      dense: ""
                    },
                    on: {
                      clicked: function($event) {
                        _vm.menuOpened = !_vm.menuOpened
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.menuOpened
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "absolute z-50 mr-4 top-0 right-full flex flex-col gap-1 bg-pure-white rounded border border-slate-400 p-2",
                          attrs: { "data-id": _vm.id }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass:
                                "px-4 py-2 hover:bg-hover-state text-left min-w-56 outline-none rounded transition-all duration-300",
                              attrs: {
                                "data-id": _vm.id,
                                to:
                                  "/appointments/details/" + _vm.appointment.id,
                                target: "_blank"
                              }
                            },
                            [
                              _c("BlTextBody2", {
                                staticClass: "text-slate-1000",
                                attrs: {
                                  "data-id": _vm.id,
                                  text: "View appointment details"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.asHeader
                            ? _c(
                                "router-link",
                                {
                                  staticClass:
                                    "px-4 py-2 hover:bg-hover-state text-left min-w-56 outline-none rounded transition-all duration-300",
                                  attrs: {
                                    "data-id": _vm.id,
                                    to: "/clients/" + _vm.appointment.client.id,
                                    target: "_blank"
                                  }
                                },
                                [
                                  _c("BlTextBody2", {
                                    staticClass: "text-slate-1000",
                                    attrs: {
                                      "data-id": _vm.id,
                                      text: "View profile"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentUser.role.includes("admin") &&
                          !_vm.asHeader
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "px-4 py-2 text-left min-w-56 outline-none rounded transition-all duration-300",
                                  class: [
                                    _vm.appointment.status !== "scheduled"
                                      ? "opacity-50 cursor-not-allowed"
                                      : "hover:bg-hover-state"
                                  ],
                                  attrs: {
                                    "data-id": _vm.id,
                                    disabled:
                                      _vm.appointment.status !== "scheduled"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit("open-reschedule")
                                    }
                                  }
                                },
                                [
                                  _c("BlTextBody2", {
                                    staticClass: "text-slate-1000",
                                    attrs: {
                                      "data-id": _vm.id,
                                      text: "Reschedule appointment"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentUser.role.includes("admin") &&
                          !_vm.asHeader
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "px-4 py-2 text-left min-w-56 outline-none rounded transition-all duration-300",
                                  class: [
                                    _vm.appointment.status === "cancelled" ||
                                    _vm.appointment.status === "completed"
                                      ? "opacity-50 cursor-not-allowed"
                                      : "hover:bg-hover-state"
                                  ],
                                  attrs: {
                                    "data-id": _vm.id,
                                    disabled:
                                      _vm.appointment.status === "cancelled" ||
                                      _vm.appointment.status === "completed"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit("open-cancellation")
                                    }
                                  }
                                },
                                [
                                  _c("BlTextBody2", {
                                    staticClass: "text-error-400",
                                    attrs: {
                                      "data-id": _vm.id,
                                      text: "Cancel appointment"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.currentUser.role.includes("admin") && _vm.asHeader
        ? _c(
            "div",
            {
              staticClass: "grid grid-cols-2 gap-4",
              attrs: { "data-id": _vm.id }
            },
            [
              _c("BlInputButton", {
                attrs: {
                  "data-id": _vm.id,
                  type: "outlined-error",
                  dense: "",
                  disabled:
                    _vm.appointment.status === "cancelled" ||
                    _vm.appointment.status === "completed",
                  label: "Cancel appointment"
                },
                on: {
                  clicked: function($event) {
                    return _vm.$emit("open-cancellation")
                  }
                }
              }),
              _vm._v(" "),
              _c("BlInputButton", {
                attrs: {
                  "data-id": _vm.id,
                  type: "outlined",
                  dense: "",
                  disabled: _vm.appointment.status !== "scheduled",
                  label: "Reschedule"
                },
                on: {
                  clicked: function($event) {
                    return _vm.$emit("open-reschedule")
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef2c24ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef2c24ca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/timeslot/SlotDetails.vue
// module id = null
// module chunks = 